import { sizeGap } from '../../util/constants';
export var emojiPickerHeightOffset = function emojiPickerHeightOffset(size) {
  if (size === 'medium') {
    return sizeGap;
  } else if (size === 'large') {
    return sizeGap * 2;
  }
  return 0;
};

// this function is being exported so it can be mocked in unit tests
export var scrollToRow = function scrollToRow(listRef, index) {
  var _listRef$current;
  (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollToRow(index);
};